import React, { useCallback } from "react";
import List from "@commonComponents/List";
import EconomicOperatorForm from "@EUForms/economicOperatorForm";
import { Grid } from "semantic-ui-react";
import InputField from "@commonComponents/formComponents/CustomInputField";
import DropDown from "@commonComponents/formComponents/CustomDropDown";
import { useSelector } from "react-redux";
import { selectCustomOfficeList, selectEconomicCustomList } from "@EUForms/selectors";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";

const EconomicOperatorDetail = ({dataSource,...rest}) => {
  const {isImportShipment} = useCurrentShipmentType()
  const economicCustomList=useSelector(isImportShipment? selectEconomicCustomList : selectCustomOfficeList)
  const renderAtLast=useCallback(({dataSource,onChangeHandler,onBlurHandler,onDropDownChange})=>{
      return(
      <>
       <Grid.Column>
      <InputField
          id={`longitude${dataSource.id}`}
          type="text"
          name="lon"
          label="LONGITUDE"
          value={dataSource.lon}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
        />
      </Grid.Column>
      <Grid.Column>
      <InputField
          id={`latitude${dataSource.id}`}
          type="text"
          name="lat"
          label="LATITUDE"
          value={dataSource.lat}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
        />
      </Grid.Column>
       <Grid.Column>
       <DropDown
             id={`customsOffice${dataSource.id}`}
             name="customsOffice"
             data={economicCustomList}
             label="CUSTOMS OFFICE"
             value={dataSource.customsOffice}
             text={dataSource.customsOffice}
             onChange={onDropDownChange}
             />
       </Grid.Column>
       </>
      )
   },[economicCustomList])
    // const renderAtFirst=useCallback(({dataSource,onDropDownChange})=>{
    //    return(
    //     <Grid.Column>
    //     <SearchableDropdown
    //        id="unLoc"
    //       label="UNLOC"
    //       name="unlocode"
    //       dropdownType="unlocode"
    //       selectedValue={dataSource.unlocode}
    //       onSelect={({ value }) => onDropDownChange(value,"unlocode")}
    //       onBlur={({value})=>{
    //           if(!value){
    //             onDropDownChange(value,"unlocode")
    //           }
    //       }}
          
    //     />
    //     </Grid.Column>
    //    )
    // },[])
  const renderItem=useCallback((item)=> <EconomicOperatorForm 
  dataSource={item} 
  key={item.id}  
  renderAtLast={renderAtLast}
  {...rest}
   />,[renderAtLast,rest]
)

  
  return <List className="responsiveGridCss"  dataSource={dataSource} renderItem={renderItem}
/>
}

export default React.memo(EconomicOperatorDetail)
